import { setTokens, logout as apiLogout } from './api';
import { showError } from './errorHandler';

const API_BASE_URL = process.env.REACT_APP_BACKEND_URL || '';

export async function login(email, pass) {
  try {
    const res = await fetch(API_BASE_URL + '/login', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login: email, password: pass }),
    });
    if (res.ok) {
      const data = await res.json();
      setTokens(data);
      localStorage.setItem('user', JSON.stringify(data.user));
      return { user: data.user };
    }
    // Try to parse structured error
    let payload = null;
    try { payload = await res.json(); } catch {}
    if (res.status === 423 && payload && payload.error === 'locked') {
      const minutes = Number(payload.minutesLeft || 0) || 0;
      return { error: 'locked', minutesLeft: minutes };
    }
    return { error: 'invalid' };
  } catch (e) {
    showError(e);
    return { error: 'network' };
  }
}

export async function register(email, pass, options = {}) {
  try {
    const notifyOnPlanReady = options?.notifyOnPlanReady;
    const res = await fetch(API_BASE_URL + '/register', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        login: email,
        password: pass,
        ...(typeof notifyOnPlanReady === 'boolean' ? { notifyOnPlanReady } : {}),
      }),
    });
    if (!res.ok) return { error: res.status };
    const data = await res.json();
    setTokens(data);
    localStorage.setItem('user', JSON.stringify(data.user));
    return { user: data.user };
  } catch (e) {
    showError(e);
    return { error: 'network' };
  }
}

export async function oauthLogin() {
  try {
    const res = await fetch(API_BASE_URL + '/oauth/gosuslugi', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        oauthId: Date.now().toString(),
        firstName: 'Иван',
        lastName: 'Иванов',
        middleName: 'Иванович',
        email: 'ivan@example.com',
        phone: '+79000000000',
        address: 'г. Москва'
      }),
    });
    if (!res.ok) return null;
    const data = await res.json();
    setTokens(data);
    localStorage.setItem('user', JSON.stringify(data.user));
    return data.user;
  } catch (e) {
    showError(e);
    return null;
  }
}

export function logout() {
  apiLogout();
}
